/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubscriptionsRouteImport } from './routes/subscriptions'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServiceIdRouteImport } from './routes/service/$id'

const SubscriptionsRoute = SubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceIdRoute = ServiceIdRouteImport.update({
  id: '/service/$id',
  path: '/service/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/legal': typeof LegalRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/service/$id': typeof ServiceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/legal': typeof LegalRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/service/$id': typeof ServiceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/legal': typeof LegalRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/service/$id': typeof ServiceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/legal' | '/subscriptions' | '/service/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/legal' | '/subscriptions' | '/service/$id'
  id: '__root__' | '/' | '/legal' | '/subscriptions' | '/service/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LegalRoute: typeof LegalRoute
  SubscriptionsRoute: typeof SubscriptionsRoute
  ServiceIdRoute: typeof ServiceIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscriptions': {
      id: '/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service/$id': {
      id: '/service/$id'
      path: '/service/$id'
      fullPath: '/service/$id'
      preLoaderRoute: typeof ServiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LegalRoute: LegalRoute,
  SubscriptionsRoute: SubscriptionsRoute,
  ServiceIdRoute: ServiceIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
